import { render, staticRenderFns } from "./TelemedicinePendingForm.vue?vue&type=template&id=3acc5fad&"
import script from "./TelemedicinePendingForm.vue?vue&type=script&lang=js&"
export * from "./TelemedicinePendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports